import React, { Dispatch, SetStateAction } from 'react'
import { Form } from 'react-angle-dashboard-components'
import { FormLabel, FormControl } from '../styles'

export const ClaimNumberSearch: React.FC<{
  formData: any
  setFormData: Dispatch<SetStateAction<any>>
}> = ({ formData, setFormData }) => {
  return (
    <Form.Group>
      <FormLabel>Claim Number</FormLabel>
      <FormControl
        placeholder="Please enter a valid claim number"
        value={formData.claimNumber}
        required
        maxLength={17}
        onChange={(e: any) =>
          setFormData((prevState: any) => ({
            ...prevState,
            claimNumber: e.target.value
          }))
        }
      ></FormControl>
    </Form.Group>
  )
}
